import { Component, EventEmitter, OnInit, Output, ViewChild, AfterViewInit, OnDestroy, Inject } from "@angular/core";
import { Router } from "@angular/router";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { MatDialog } from "@angular/material/dialog";
import { HttpClient } from "@angular/common/http";
import { layoutRoute } from "@jeanologia/ng-layout/lib/layout-route.interface";
import { CookieNames, JeanologiaNgSsoauthService } from "@jeanologia/ng-ssoauth";
import { LayoutComponent } from "@jeanologia/ng-layout";
import { TranslateService, LangChangeEvent } from "@ngx-translate/core";
import { BehaviorSubject, Observable, Observer, Subscription } from "rxjs";
import moment from "moment";

import { ENVIRONMENT } from "../../../core/token";
import { MenuConstants } from "../../models/constants/menu_constants";
import { AdminMenuConstants } from "../../models/constants/admin_menu_constants";
import { Constants, COUPONS_PATH } from "../../models/constants/_constants";
import { SatConstants } from "../../models/constants/sat_menu_constants";
import { ClientModel } from "../../../shared/entities/client.model";
import { RedeemCouponComponent } from "../../../shared/components/modals/redeem-coupon/redeem-coupon.component";
import { CouponResponseComponent } from "../../../shared/components/modals/coupon-response/coupon-response.component";
import { AuthenticationService } from "../../../core/services/user/authentication.service";

@Component({
	selector: "app-lightelier-layout",
	styleUrls: ["./default-layout.component.scss"],
	templateUrl: "./default-layout.component.html",
	animations: [
		trigger("activeChatbot", [
			state(
				"closed",
				style({
					top: "100%",
					height: "0%",
					display: "none",
				}),
			),
			state(
				"open",
				style({
					top: "50%",
					height: "50%",
					display: "unset",
				}),
			),
			transition("open => closed", [animate("0.25s")]),
			transition("closed => open", [animate("0.1s")]),
		]),
	],
	standalone: false,
})
export class DefaultLayoutComponent implements OnInit, AfterViewInit, OnDestroy {
	@Output() public languageChange = new EventEmitter<string>();
	@ViewChild("layout") private layout!: LayoutComponent;

	public logo: string = "";
	public footerText: string = "";

	public userInfoObserver!: Observer<any>;
	public userInfoSubject = new BehaviorSubject<any>(null);

	public routes: layoutRoute[] = [];
	public userScope: string[] = [];
	public activeChatbot: boolean = false;
	public subscription = new Subscription();

	private userMenuRoutes: MenuConstants;
	private adminMenuRoutes: AdminMenuConstants;
	private satMenuRoutes: SatConstants;

	constructor(
		@Inject(ENVIRONMENT) protected environment,
		@Inject(COUPONS_PATH) private coupon_path: string,
		private auth_service: AuthenticationService,
		private http: HttpClient,
		private dialog: MatDialog,
		private router: Router,
		private ssoauth_service: JeanologiaNgSsoauthService,
		private translate: TranslateService,
	) {
		this.logo = environment.cdnEndpoint + "assets/JStore 214x90.png";
		this.footerText =
			new Date().getFullYear() +
			` ©&nbsp;<a class="link" href="http://www.jeanologia.com"><strong _ngcontent-c7="">Jeanologia</strong></a>.&nbsp;All rights reserved.&nbsp;<a class="link" target="_blank" href="https://jeanologiacdn.blob.core.windows.net/global/ToS/TOS_cloud.pdf">Terms of Use</a>. Version ${environment.version} `;

		this.adminMenuRoutes = new AdminMenuConstants(environment, translate);
		this.userMenuRoutes = new MenuConstants(environment, translate);
		this.satMenuRoutes = new SatConstants(environment, translate);
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	ngAfterViewInit() {
		this.layout.setLanguage(localStorage.lang);
	}

	public ngOnInit(): void {
		this.setUserInfo();
		this.routes = this.getRoutesByUserType()!;
		this.translate.onLangChange.subscribe((params: LangChangeEvent) => {
			this.routes = this.getRoutesByUserType()!;
		});
	}

	public setUserInfo(): void {
		this.userScope = this.ssoauth_service.getCookie(CookieNames.JEANAPI).token.scope;
		this.ssoauth_service.getUserInfo().subscribe((user: ClientModel) => {
			this.userInfoSubject.next(user);
		});
	}

	public getUser(): any {
		const userInfo = new Observable((observer) => {
			this.userInfoObserver = observer;
		});
		return userInfo;
	}

	public getRoutesByUserType(): layoutRoute[] | undefined {
		const user_roles: string[] = this.auth_service.getRolScopes();

		if (user_roles && Array.isArray(user_roles)) {
			let routesMenu: layoutRoute[] = [];

			if (user_roles.includes("marketplace-admin")) {
				routesMenu = this.adminMenuRoutes.getRoutes();
			} else if (user_roles.includes("marketplace-buyer")) {
				if (user_roles.includes("marketplace-sat")) {
					routesMenu = this.satMenuRoutes.getRoutes();
				} else {
					routesMenu = this.userMenuRoutes.getRoutes();
				}
			} else {
				this.auth_service.logOut();
			}

			return routesMenu!;
		}
	}

	public checkUserType(type?: string): boolean {
		if (type && type === "admin") {
			if (
				this.userScope &&
				Array.isArray(this.userScope) &&
				(this.userScope.indexOf(Constants.USER_ROLES.admin) !== -1 || this.userScope.indexOf(Constants.USER_ROLES.admin_user) !== -1)
			) {
				return true;
			}
		}
		return false;
	}

	public changeLanguage($event: string): void {
		if (localStorage.lang && localStorage.lang.match(/en|tr|jp|it|fr|pt|zh|es/)) {
			localStorage.lang = $event;
			this.translate.use(localStorage.lang);
		} else {
			localStorage.lang = this.translate.currentLang;
			this.translate.use(localStorage.lang);
		}
		this.layout.setLanguage(localStorage.lang);
		this.changeMomentLocale(localStorage.lang);
	}

	public logOutFromServer(): void {
		localStorage.removeItem("user");
		this.ssoauth_service.logout();
	}

	public changeMomentLocale(locale?: string): void {
		if (locale) {
			let momentLocale: string = locale;
			switch (locale) {
				case "en":
					momentLocale = "en-gb";
					break;
				case "jp":
					momentLocale = "ja";
					break;
				case "zh":
					momentLocale = "zh-cn";
					break;
			}
			moment.locale(momentLocale);
		}
	}

	public navigateToSupport(): void {
		this.router.navigate(["/private/support"]);
	}

	public navigateToProfile(): void {
		//this.router.navigate(['/private/profile']);
	}

	public openRedeemCoupon(): void {
		const dialogRef = this.dialog.open(RedeemCouponComponent, {
			width: "400px",
			height: "200px",
		});

		const su = dialogRef.afterClosed().subscribe((code) => {
			if (code) {
				const new_path = `${this.coupon_path}/validate/${code}`;

				const su2 = this.http.post(new_path, {}).subscribe({
					next: () => {
						this.openResponsePopup();
					},
					error: (response) => {
						this.openResponsePopup(response.error);
					},
				});
				this.subscription.add(su2);
			}
		});

		this.subscription.add(su);
	}

	public openResponsePopup(error_response?: any): void {
		const dialogRef = this.dialog.open(CouponResponseComponent, {
			width: "300px",
			height: "220px",
			data: { error_response },
		});
	}
}
